import miniHeader from "./miniHeader/miniHeader.vue";
import header from "./header/header.vue";
import footer from "./footer/footer.vue";

export default {
  components: {
    "app-mini-header": miniHeader,
    "app-header": header,
    "app-footer": footer,
  },

  mounted() {
    document.title = "Toko buku terbesar | Togamas";

    document
      .querySelectorAll("meta[property=og\\:title]")[0]
      .setAttribute("content", "Toko buku terbesar | Togamas");

    document
      .querySelectorAll("meta[property=og\\:image]")[0]
      .setAttribute("content", "/togamas-mobile.png");

    document
      .querySelectorAll("meta[property=og\\:description]")[0]
      .setAttribute(
        "content",
        "Beli buku diskon di Togamas! Toko buku diskon seumur hidup. Menjual semua genre buku, menjual alat tulis, aksesories, kosmetik ringan dan produk teknologi."
      );
  },
};
